import { AchRefundApiRoutes } from '@lib/enums/api/AchRefundApiRoutes';
import { ConsumerApiRoutes } from '@lib/enums/api/ConsumerApiRoutes';
import { ContactApiRoutes } from '@lib/enums/api/ContactApiRoutes';
import { ContractApiRoutes } from '@lib/enums/api/ContractApiRoutes';
import { ContractRetentionApiRoutes } from '@lib/enums/api/ContractRetentionApiRoutes';
import { DialerApiRoutes } from '@lib/enums/api/DialerApiRoutes';
import { EcommerceApiRoutes } from '@lib/enums/api/EcommerceApiRoutes';
import { EmailApiRoutes } from '@lib/enums/api/EmailApiRoutes';
import { HomeApiRoutes } from '@lib/enums/api/HomeApiRoutes';
import { QuoteApiRoutes } from '@lib/enums/api/QuoteApiRoutes';
import { RatesApiRoutes } from '@lib/enums/api/RatesApiRoutes';
import { ReportApiRoutes } from '@lib/enums/api/ReportApiRoutes';
import { UserApiRoutes } from '@lib/enums/api/UserApiRoutes';
import { VehicleApiRoutes } from '@lib/enums/api/VehicleApiRoutes';

// Should be 1 to 1 with Gateway controllers if possible
// If a group grows to be 3< entries, create an ApiRoutes.ts file for it
// e.g. Contracts: ContractApiRoutes,
export const ApiRoutes = {
  AchRefunds: AchRefundApiRoutes,
  Activities: {
    Search: '/activities/search',
  },
  Addresses: {
    AddressValidation: '/addresses/validate',
    AddressZipState: '/addresses/state/:id',
    AllowedMailTypes: '/addresses/allowed-mail-types',
  },
  Agents: {
    All: '/agents',
    ById: '/agents/:id',
  },
  Banks: {
    Banks: '/banks/:id',
    ConsentDetails: '/banks/:id/consent-details',
    ConsentDetailsRefresh: '/banks/:id/consent-details/refresh',
  },
  Carts: {
    ByRefId: '/carts/:id',
    GetSavedPayments: '/carts/:id/saved-payments',
    SavedPayments: '/carts/:id/saved-payments/:id',
    TransactionAction: '/carts/:id/transactions/:id/:id',
    ProcessExceptionPayment: '/carts/:id/exception-payment',
    ProcessManualTransaction: '/carts/:id/manual-payment-entry',
    ManualTransactionTypes: '/carts/:id/manual-transaction-types',
  },
  Claims: {
    ByContractNumber: '/claims/:id',
    VinAudit: '/claims/vin/:id/audit',
  },
  Commissions: {
    Commissions: '/commissions/sales/calculate',
  },
  Contracts: ContractApiRoutes,
  ContractRetentions: ContractRetentionApiRoutes,
  Contacts: ContactApiRoutes,
  Consumers: ConsumerApiRoutes,
  Dialer: DialerApiRoutes,
  Ecommerce: EcommerceApiRoutes,
  Emails: EmailApiRoutes,
  Home: HomeApiRoutes,
  Leads: {
    SearchByFinderCode: '/leads',
    Search: '/leads/search',
    SearchMail: '/leads/mail/search',
    SearchInternet: '/leads/internet/search',
  },
  MagicLinks: {
    PayByBank: '/magiclinks/pay-by-bank/:id',
  },
  MerchantTypes: {
    MerchantTypes: '/merchanttypes',
  },
  Policies: {
    Sales: '/policies/sales',
  },
  Quotes: QuoteApiRoutes,
  Rates: RatesApiRoutes,
  Reports: ReportApiRoutes,
  Roles: {
    AllV2: '/roles/v2',
    StateSpecificPermissions: '/roles/state-specific-permissions',
  },
  Settings: {
    All: '/settings',
  },
  Sms: {
    PayByBank: '/sms/pay-by-bank/:id/send',
  },
  Users: UserApiRoutes,
  Vehicles: VehicleApiRoutes,
  VehicleServiceShops: {
    VehicleServiceShops: '/vehicleserviceshops/:id',
  },
};

export type TApiRoutes = AchRefundApiRoutes;
